import * as React from 'react'

import { styled } from '~/styled'

import { Text } from '../text/Text'
import { SegmentedControlContext } from './SegmentedControlContext'

const StyledHeading = styled(
  Text,
  {
    base: ['font-body', 'text-text-regular'],
    variants: {
      size: {
        sm: ['text-sm', 'leading-[1.53]'],
        md: ['text-md', 'leading-normal'],
        lg: ['text-lg', 'leading-[1.52]']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

export const SegmentedControlHeading = (
  props: Omit<React.ComponentProps<typeof StyledHeading>, 'size'>
): React.JSX.Element => {
  const { size } = React.useContext(SegmentedControlContext)

  return <StyledHeading {...props} size={size} />
}
